import { styled } from "@mui/material/styles";
import { Grid, Link, IconButton, Button, Typography } from "@mui/material";

export const StyledGrid = styled(Grid)(({ theme }) => ({
  padding: "12px 16px",
  [theme.breakpoints.up("mobile")]: {
    padding: "12px 22px",
  },
}));

export const StyledMenuItem = styled(Link)({
  margin: "16px 0",
  display: "block",
});

export const StyledMenuItemButton = styled(Button)({
  margin: "16px 0",
  display: "block",
});

export const StyledButton = styled(Button)({
  margin: "16px 0",
});

export const Message = styled(Typography)({
  maxWidth: 470,
  margin: "16px 0",
});

export const Action = styled(IconButton)(({ theme }) => ({
  marginRight: 10,
  [theme.breakpoints.up("mobile")]: {
    marginRight: 32,
  },
}));
